const LOG_KEY = 'trip_debug_log';
const MAX_ENTRIES = 2000;

export function tripLog(msg: string) {
  try {
    const raw = localStorage.getItem(LOG_KEY);
    const entries: string[] = raw ? JSON.parse(raw) : [];
    const ts = new Date().toTimeString().slice(0, 8);
    entries.push(`${ts} ${msg}`);
    if (entries.length > MAX_ENTRIES) entries.splice(0, entries.length - MAX_ENTRIES);
    localStorage.setItem(LOG_KEY, JSON.stringify(entries));
  } catch { /* ignore */ }
  console.log(msg);
}

export function getTripLog(): string[] {
  try {
    const raw = localStorage.getItem(LOG_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
}

export function clearTripLog() {
  try { localStorage.removeItem(LOG_KEY); } catch { /* ignore */ }
}
